import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import logo from 'images/general/logo.png';
import Sidebar from './mobile-sidebar';

import {changeMobileMenu} from 'redux/actions/portal/system';
import {MenuLeft, MenuRight, Logo, Toggle} from './components';
import {HeaderWrap, Toggler, Menu, DropdownMenu, DropdownMenuWrapper} from 'components/header/components';
import {signOut, loadUser} from '../../redux/actions/auth';

import onClickOutside from "react-onclickoutside";

const mapStateToProps = (state) => ({
  menuOpen: state.system.get('toggleMobileMenu'),
  token: state.auth.get('token'),
  user: state.auth.get('user')
});

const mapDispatchToProps = (dispatch) => ({
  toggleMenu: (event) => dispatch(changeMobileMenu()),
  signOut: (event) => dispatch(signOut()),
  loadUser: () => dispatch(loadUser())
});

class Header extends Component {

  constructor(props){
    super(props);

    this.state = {
      dropdown: false
    }
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState({
      dropdown: !this.state.dropdown
    })
  }

  handleClickOutside = evt => {
		this.setState({
			dropdown: false
		})
	  };


  componentDidMount() {
    this.props.loadUser();
  }

  render() {

    if (this.props.user === undefined) {
      return (
        <HeaderWrap>
          <Grid>
            <Menu>
              <MenuLeft>
                <Logo>
                  <Link to="/"><img src={logo} alt="Логотип" /></Link>
                </Logo>
                <Toggle onClick={this.props.toggleMenu}>
      						<i className="fa fa-bars" aria-hidden="true"></i>
            		</Toggle>
                <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
                <li><Link to="/news">Новини</Link></li>
                <li><Link to="/infocenter">Інфоцентр</Link></li>
                <li><Link to="/about">Про Портал</Link></li>
              </MenuLeft>
                <MenuRight>
                  <li><Link to="/registration"><i className="fa fa-sign-in" aria-hidden="true"></i><span>Реєстрація</span></Link></li>
                  <li><Link to="/login"><i className="fa fa-power-off" aria-hidden="true"></i><span>Вхід</span></Link></li>
                </MenuRight>
            </Menu>
          </Grid>
            <Sidebar/>
        </HeaderWrap>);
    }

    return(
      <HeaderWrap>
        <Grid>
          <Menu>
            <MenuLeft>
              <Logo>
                <Link to="/"><img src={logo} alt="Логотип" /></Link>
              </Logo>
              <Toggle onClick={this.props.toggleMenu}>
    						<i className="fa fa-bars" aria-hidden="true"></i>
          		</Toggle>
              <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
              <li><Link to="/news">Новини</Link></li>
              <li><Link to="/infocenter">Інфоцентр</Link></li>
              <li><Link to="/about">Про Портал</Link></li>
            </MenuLeft>

            {this.props.token ?

              (
              <DropdownMenuWrapper>
                <Toggler onClick={this.toggleDropdown}>
                  <i className="fa fa-user" aria-hidden="true"></i>
                </Toggler>
                <DropdownMenu visible={this.state.dropdown}>
                  <li>
                    {this.props.user.get('last_name')} {this.props.user.get('first_name')}
                    <div>{this.props.user.get('email')}</div>
                  </li>
                  <li><Link to="/cabinet">Кабінет користувача</Link></li>
                  {this.props.user.get('is_staff_operator') &&
                    <li>
                      <Link to="/operator"><span>Кабінет оператора</span></Link>
                    </li>
                  }
                  {(this.props.user.get('is_staff_admin') || this.props.user.get('is_staff_manager_document') || this.props.user.get('is_superuser') || this.props.user.get('is_admin_institution')) &&
                    <li>
                      <Link to="/admin"><span>Службовий кабінет</span></Link>
                    </li>
                  }
                  {(this.props.user.get('is_staff_admin') || this.props.user.get('is_superuser') || this.props.user.get('is_registry')) &&
                    <li>
                      <Link to="/registry"><span>Реєстратура</span></Link>
                    </li>
                  }

                  {(this.props.user.get('is_superuser') || this.props.user.get('is_staff_manager_institution') || this.props.user.get('')) &&
                    <li>
                      <Link to="/administration"><span>Адміністрація</span></Link>
                    </li>
                  }

                  <li>
                    <Link to="/" onClick={this.props.signOut}><i className="fa fa-sign-out" aria-hidden="true"></i><span>Вийти</span></Link>
                  </li>
                </DropdownMenu>
              </DropdownMenuWrapper>
            )

            :
            (
              <MenuRight>
                <li><Link to="/registration"><i className="fa fa-sign-in" aria-hidden="true"></i><span>Реєстрація</span></Link></li>
                <li><Link to="/login"><i className="fa fa-sign-in" aria-hidden="true"></i><span>Вхід</span></Link></li>
              </MenuRight>
            )}

          </Menu>
        </Grid>
        <Sidebar/>
      </HeaderWrap>
    )
  }
}

Header.propTypes = {
  menuOpen: PropTypes.bool,
  toggleMenu: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(onClickOutside(Header));



// WEBPACK FOOTER //
// ./src/system/header/index.js